import { render } from "./OapMenShadeMatcher.vue?vue&type=template&id=153d2c58"
import script from "./OapMenShadeMatcher.vue?vue&type=script&lang=js"
export * from "./OapMenShadeMatcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__